<template>
  <Bar 
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
  ></Bar>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale)


export default {
  components: {
    Bar
  },

  props: {
    records: {
      type: Array,
      required: true
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    cssClasses: {
      default: '',
      type: String
    },
    plugins: {
      type: Array,
      default: () => []
    }    
  },
  
  computed: {
    chartData() {
      return {
        labels: this.records.map(record => parseInt(record.funding_year)),
        datasets: [
          {
            data: this.records.map(record => record.sum_funded),
            backgroundColor: this.chartColors('dark'),
            hoverOffset: 10,
            label: this.$t('Funded amount'),
          },
          {
            data: this.records.map(record => (record.sum_unfunded)),
            backgroundColor: this.chartColors('light'),
            hoverOffset: 10,
            label: this.$t('Unfunded amount'),
          }
        ] 
      }
    },

    styles() {
      return {
        height: `${100 + (this.records.length * 30)}px`,
        position: 'relative',
      }
    },

    chartOptions() {
      return {
        
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'x',
        scaleShowValues: true,
        scales: {
          y: {
            stacked: true,
            ticks: {
              autoSkip: false,
              callback: (value) => {
                return this.formatMoney(value);
              }
            }
          },
          x: { 
            stacked: true,
          }
        },
        plugins: {
          legend: {
            display: true,
          },
          tooltip: {
            mode: 'x',
            callbacks: {
              label: (context) => this.formatLabel(context),
            }
          }
        },
        layout: {
          padding: 15,
        }
      }
    }
  },

  methods: {
    chartColors(type) {
      return this.records.map(() => {
        return (type==='dark') ? 'rgb(0 122 179)' : 'rgb(253 185 36)'
      });
      /*
      const colorArray = [];
      this.records.forEach(row => {
        colorArray.push
      })
      return (type==='dark') ? 'rgb(0 122 179)' : 'rgb(253 185 36)'
      // This function will automatically generate colors based on the number of records
      for (let i = 0; i < this.records.length; i++) {
        const hue = ((i + 1) * (360/this.records.length)) % 360;
        const color = `hsl(${hue}, 70%, ${(type==='dark') ? '50' : '85' }%)`;
        colorArray.push(color);
      }
      return colorArray;
      */
    },
    
    formatMoney(val) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
 }).format(val);
    },

    formatLabel(context) {
      let label = context.dataset.label || '';
      if (label) {
        label += (process.env.VUE_APP_I18N_LOCALE=== 'en') ? ': ' : ' : ';
        if (context.parsed !== null) {
          label += this.formatMoney(context.parsed.y);
        }
        return label;
      }
    },

  }
}

</script>

<style>
.chart_container {
  position: relative;
  margin: auto;
}
</style>
